export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOADING = 'AUTH_LOADING';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';
export const GET_USERS_LOADING = 'GET_USERS_LOADING';
export const EDIT_USERS_SUCCESS = 'EDIT_USERS_SUCCESS';
export const EDIT_USERS_ERROR = 'EDIT_USERS_ERROR';
export const EDIT_USERS_LOADING = 'EDIT_USERS_LOADING';
export const CLEAR_SUCCESS = 'CLEAR_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';
export const DELETE_USER_LOADING = 'DELETE_USER_LOADING';
export const GET_PRODUCTS_LOADING = 'GET_PRODUCTS_LOADING';
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const EDIT_PRODUCT_LOADING = 'EDIT_PRODUCT_LOADING';
export const EDIT_PRODUCT_ERROR = 'EDIT_PRODUCT_ERROR';
export const EDIT_PRODUCT_SUCCESS = 'EDIT_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_LOADING = 'DELETE_PRODUCT_LOADING';
export const DELETE_PRODUCT_ERROR = 'DELETE_PRODUCT_ERROR';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
export const ADD_NEW_PRODUCT_LOADING = 'ADD_NEW_PRODUCT_LOADING';
export const ADD_NEW_PRODUCT_ERROR = 'ADD_NEW_PRODUCT_ERROR';
export const ADD_NEW_PRODUCT_SUCCESS = 'ADD_NEW_PRODUCT_SUCCESS';
export const GET_ORDERS_LOADING = 'GET_ORDERS_LOADING';
export const GET_ORDERS_ERROR = 'GET_ORDERS_ERROR';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const EDIT_ORDER_LOADING = 'EDIT_ORDER_LOADING';
export const EDIT_ORDER_ERROR = 'EDIT_ORDER_ERROR';
export const EDIT_ORDER_SUCCESS = 'EDIT_ORDER_SUCCESS';
export const DELETE_ORDER_LOADING = 'DELETE_ORDER_LOADING';
export const DELETE_ORDER_ERROR = 'DELETE_ORDER_ERROR';
export const DELETE_ORDER_SUCCESS = 'DELETE_ORDER_SUCCESS';
export const ADD_NEW_ORDER_LOADING = 'ADD_NEW_ORDER_LOADING';
export const ADD_NEW_ORDER_ERROR = 'ADD_NEW_ORDER_ERROR';
export const ADD_NEW_ORDER_SUCCESS = 'ADD_NEW_ORDER_SUCCESS';
